/**
 * Created by 一灏
 */
var data = {};
var globalData = {
  getData: function getData(key) {
    if (!data[key]) {
      return null;
    }
    return data[key];
  },
  setData: function setData(key, value) {
    data[key] = value;
  }
};
export default globalData;